import { z } from 'zod';

import { SupplierPaymentTermsKindSchema } from './supplier-role.schemas.js';

export const AddSupplierRoleBodySchema = z
  .object({
    paymentTermsKind: SupplierPaymentTermsKindSchema,
    paymentDays: z.number().int().positive().nullable().optional(),
    internalCode: z.string().trim().max(50).nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
  })
  .superRefine((body, ctx) => {
    if (
      body.paymentTermsKind === 'NET_DAYS' &&
      (body.paymentDays === undefined || body.paymentDays === null)
    ) {
      ctx.addIssue({
        code: 'custom',
        message: 'paymentDays required for NET_DAYS',
        path: ['paymentDays'],
      });
    }
    if (body.paymentTermsKind !== 'NET_DAYS' && body.paymentDays != null) {
      ctx.addIssue({
        code: 'custom',
        message: 'paymentDays must be null',
        path: ['paymentDays'],
      });
    }
  });

export type AddSupplierRoleBody = z.infer<typeof AddSupplierRoleBodySchema>;

export const AddSupplierRoleResponseSchema = z.object({
  supplierRoleId: z.uuid(),
});

export type AddSupplierRoleResponse = z.infer<typeof AddSupplierRoleResponseSchema>;
